@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.tree-nav-container {
  height: 100%;
}

.tree-and-batches {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > * {
    position: relative;

    &:first-child {
      z-index: 1;
    }

    &:last-child {
      z-index: 2;
    }
  }
}

.exit-advanced-search-text {
  color: @left-nav--search-area--text-color;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 9px 0;

  .advanced-search-exit-arrow {
    padding: 6% 5.5%;
    fill: @left-nav--search-area--icon-color;
  }
}

.advanced-search-text {
  color: @left-nav--search-area--text-color;
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  padding: 0 10px 6px;
  box-shadow: inset -3px 0 2px -2px @left-nav--search-area--box-shadow-color;
}

.advanced-search-button {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  :focus {
    background: transparent;
  }
}

.search-area {
  height: 100%;
  overflow-y: auto;
}

.search-area-highlighted {
  background: var(--left-nav--advanced-search-active-color);
}

.search-area-buttons {
  border-bottom: 1px solid @left-nav--search-area--border-bottom-color;
}
